const swiperItems = () => {
	
	/*************************************************
	 * Cols 4 Cards
	*************************************************/
	const $cols4Cards = $('.cols-4-cards');
	
	if ($cols4Cards.length) {
		
		$cols4Cards.each(function() {
			
			const $cols4Card = $(this);

			new Swiper($cols4Card[0], {
				slidesPerView: 1.2,
				spaceBetween: 24,
				autoHeight: false,
				freeMode: {
					enabled: true,
					sticky: true,
				},
				modules: [FreeMode],
				breakpoints: {
					768: {
						slidesPerView: 2.5,
					},
					1024: {
						slidesPerView: 4,
					},
				},
			});
			
		});
		
	}
	
	/*************************************************
	 * Testimonials Slider
	*************************************************/
	const $testimonialsSliders = $('.testimonials-slider');
	
	if ($testimonialsSliders.length) {
		
		const containerPaddingRoot = getComputedStyle(document.documentElement);
		const containerPadding = containerPaddingRoot.getPropertyValue('--container-padding');
		
		$testimonialsSliders.each(function() {
			
			const $testimonialsSlider = $(this);
			
			new Swiper($testimonialsSlider[0], {
				slidesPerView: 1,
				spaceBetween: containerPadding,
				autoHeight: true,
				loop: true,
				modules: [Navigation],
				navigation: {
					nextEl: '.testimonial-next',
					prevEl: '.testimonial-prev',
				},
			});
			
		});
	}
	
	/*************************************************
	 * Image Slider Block Full
	*************************************************/
	const $imageSliderBlockFull = $('.comp__image-slider-block.layout-full .image-slider-block');
	
	if ($imageSliderBlockFull.length) {
		$imageSliderBlockFull.each(function() {
			
			const $imageSlider = $(this);
			
			new Swiper($imageSlider[0], {
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: true,
				loop: true,
				modules: [Navigation],
				navigation: {
					nextEl: '.image-slider-block-next',
					prevEl: '.image-slider-block-prev',
				},
			});
			
		});
	}
	
	/*************************************************
	* Image Slider Block Centered
	*************************************************/
	const $imageSliderBlockCentered = $('.comp__image-slider-block.layout-centered .image-slider-block');

	if ($imageSliderBlockCentered.length) {
		$imageSliderBlockCentered.each(function() {

			const $imageSlider = $(this);

			new Swiper($imageSlider[0], {
				slidesPerView: 1.5,
				spaceBetween: 0,
				centeredSlides: true,
				initialSlide: 1,
				autoHeight: false,
				loop: true,
				modules: [Navigation],
				navigation: {
					nextEl: '.image-slider-block-next',
					prevEl: '.image-slider-block-prev',
				},
			});

		});
	}
	
};

export { swiperItems };